/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_BirthInputs */

const en_us2_search_field_birth = /** @type {(inputs: Search_Field_BirthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date of birth`)
};

const pt_br2_search_field_birth = /** @type {(inputs: Search_Field_BirthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data de nascimento`)
};

const es_419_search_field_birth = /** @type {(inputs: Search_Field_BirthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de nacimiento`)
};

const pt_pt2_search_field_birth = /** @type {(inputs: Search_Field_BirthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data de nascimento`)
};

const fr_fr2_search_field_birth = /** @type {(inputs: Search_Field_BirthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date de naissance`)
};

const de_de2_search_field_birth = /** @type {(inputs: Search_Field_BirthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geburtsdatum`)
};

const it_it2_search_field_birth = /** @type {(inputs: Search_Field_BirthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data di nascita`)
};

/**
* | output |
* | --- |
* | "Date of birth" |
*
* @param {Search_Field_BirthInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_birth = /** @type {((inputs?: Search_Field_BirthInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_BirthInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_birth(inputs)
	if (locale === "es-419") return es_419_search_field_birth(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_birth(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_birth(inputs)
	if (locale === "de-DE") return de_de2_search_field_birth(inputs)
	if (locale === "it-IT") return it_it2_search_field_birth(inputs)
	return en_us2_search_field_birth(inputs)
});
export { search_field_birth as "search.field_birth" }